<template>
  <AssignedUsersFilter :id="id" v-model="modelValue" entity-type="order" />
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';

import { OrderSearchCriteria, ShipmentSearchCriteria } from '@/model';

import AssignedUsersFilter from '@/components/search/AssignedUsersFilter.vue';

const modelValue = defineModel({
  type: Object as PropType<OrderSearchCriteria | ShipmentSearchCriteria>,
  required: true,
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});
const { id } = toRefs(props);
</script>
